<div class="report-analytics" test-id="reportAnalytics">
  <div *ngIf="state === 'loading'" class="report-analytics-state" test-id="reportAnalyticsLoading">
    <span class="gp-spinner"></span>
    <p class="m-t-sm">{{ 'REPORTS.ai_analytics_loading' | translate }}</p>
  </div>

  <div *ngIf="state === 'error'" class="report-analytics-state" test-id="reportAnalyticsError">
    <gp-message type="danger" text="REPORTS.ai_analytics_error"></gp-message>
    <button type="button" class="btn btn-sm btn-outline-default m-t-sm" test-id="reportAnalyticsRetry" (click)="retry()">
      {{ 'REPORTS.ai_analytics_retry' | translate }}
    </button>
  </div>

  <div *ngIf="state === 'empty'" class="report-analytics-state" test-id="reportAnalyticsEmpty">
    <gp-illustrated-message [width]="'50%'" [text]="'REPORTS.no_results'"></gp-illustrated-message>
  </div>

  <ng-container *ngIf="state === 'done' && selected">
    <div class="report-analytics-notices">
      <gp-message *ngIf="result?.dataset?.truncated" type="warning" test-id="reportAnalyticsTruncated">
        {{ 'REPORTS.ai_analytics_truncated' | translate: {analysed: result.dataset.analysedRows, total: result.dataset.totalRows} }}
      </gp-message>
      <gp-message *ngIf="result && !result.aiGenerated" type="info" text="REPORTS.ai_analytics_not_ai" test-id="reportAnalyticsNotAi">
      </gp-message>
    </div>

    <form class="report-analytics-refine m-b-md" (ngSubmit)="submitRefine()">
      <div class="input-group">
        <input type="text"
               class="form-control"
               name="refineInstruction"
               maxlength="500"
               test-id="reportAnalyticsRefineInput"
               [placeholder]="'REPORTS.ai_analytics_refine_placeholder' | translate"
               [(ngModel)]="refineInstruction"
               [disabled]="refining">
        <span class="input-group-btn">
          <button type="submit" class="btn btn-sm btn-outline-default" test-id="reportAnalyticsRefineButton"
                  [disabled]="refining || !refineInstruction?.trim()">
            <i *ngIf="refining" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
            {{ 'REPORTS.ai_analytics_refine' | translate }}
          </button>
        </span>
      </div>
      <small *ngIf="refineMessage" class="text-muted" test-id="reportAnalyticsRefineMessage">{{ refineMessage }}</small>
      <div *ngIf="refineFollowUps.length" class="report-analytics-follow-ups m-t-xs" test-id="reportAnalyticsFollowUps">
        <small class="text-muted">{{ 'REPORTS.ai_analytics_follow_ups' | translate }}</small>
        <button *ngFor="let followUp of refineFollowUps; let index = index"
                type="button"
                class="btn btn-xs btn-outline-default"
                [attr.test-id]="'reportAnalyticsFollowUp' + index"
                [disabled]="refining"
                (click)="applyFollowUp(followUp)">
          {{ followUp }}
        </button>
      </div>
    </form>

    <div class="report-analytics-suggestions btn-group" role="group" test-id="reportAnalyticsSuggestions">
      <button *ngFor="let suggestion of suggestions; let index = index"
              type="button"
              class="btn btn-sm"
              [class.btn-fill-default]="index === selectedIndex"
              [class.btn-outline-default]="index !== selectedIndex"
              [attr.test-id]="'reportAnalyticsSuggestion' + index"
              (click)="select(index)">
        {{ suggestion.spec.title || ('REPORTS.ai_analytics_chart' | translate: {index: index + 1}) }}
      </button>
    </div>

    <p *ngIf="selected.spec.rationale" class="text-muted m-t-md">{{ selected.spec.rationale }}</p>

    <div *ngIf="selected.spec.chartType === ChartType.KPI; else chartTemplate" class="report-analytics-kpis" test-id="reportAnalyticsKpis">
      <div *ngFor="let kpi of selected.data.kpis" class="report-analytics-kpi">
        <div class="report-analytics-kpi-value">{{ kpi.value | number: '1.0-2' }}</div>
        <div class="text-muted">
          {{ ('REPORTS.ai_analytics_aggregation_' + kpi.aggregation.toLowerCase()) | translate }} {{ kpi.label }}
        </div>
      </div>
    </div>
    <ng-template #chartTemplate>
      <gp-echart *ngFor="let chart of renderedCharts; trackBy: trackChart"
                 [options]="chart.option"
                 [width]="'100%'"
                 [height]="'420px'"
                 test-id="reportAnalyticsChart">
      </gp-echart>
      <small *ngIf="isApproximate" class="text-muted">{{ 'REPORTS.ai_analytics_approximate' | translate }}</small>
    </ng-template>

    <gp-message *ngIf="selected.insight" class="report-analytics-insight" type="info" size="large"
                title="REPORTS.ai_analytics_insight" test-id="reportAnalyticsInsight">
      <span>{{ selected.insight }}</span>
      <small class="text-muted" test-id="reportAnalyticsDisclaimer">{{ 'REPORTS.ai_analytics_disclaimer' | translate }}</small>
    </gp-message>
  </ng-container>
</div>
